const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_SIZE)

export const apiMealSizes = {
	fetchDietMealSizes: async (
		search: string | undefined,
		type: 'meal' | 'prep_meal' | undefined,
		page: number = 1,
		perPage: number = 25,
	) => {
		const { data, meta } = await apiCommon<IDietMealSize[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: search, meal_kind: type }),
		})
		return { data: data.map(d => DietMealSize(d)), meta }
	},
}
